import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'
import { gatewayStatusStr, gatewayVariant } from '@/constants/gatewayStatus'

export default [
    {
        field: 'user_id',
        title: i18n.t('label.user_id'),
        sortable: true,
        width: 70,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.first_and_last_name'),
        sortable: false,
        width: 140,
        textAlign: 'center'
    },
    {
        field: 'wage_plan',
        title: i18n.t('label.wage_plan'),
        sortable: false,
        width: 140,
        template: (item) => {
            if (item.wage_plan === 'PERCENT'){
                return `<span class="badge badge-dark">درصدی</span>`;
            }
            if (item.wage_plan === 'FIXED'){
                return `<span class="badge badge-success">ثابت</span>`;
            }
            else {
                return `<span class="badge badge-info">ماهیانه</span>`;
            }
        },
        textAlign: 'center'
    },
    {
        field: 'wage_amount',
        sortable: true,
        title: i18n.t('label.wage'),
        width: 140,
        template: (item) => {
            if (item.wage_plan === 'PERCENT'){
                return `<span>${item.wage_amount}%</span>`;
            }
            if (item.wage_plan === 'FIXED'){
                return `<span>${item.wage_amount}</span>`;
            }
            else {
                return `<span>${item.wage_amount} ${i18n.t('label.rial')}</span>`;
            }
        },
        textAlign: 'center'
    },
    {
        field: 'pay_link',
        sortable: false,
        title: i18n.t('label.pay_link'),
        width: 140,
        template: (item) => {
                return `<a href="${item.pay_link}">${item.pay_link}</a>`;
        },
        textAlign: 'center'
    },
    {
        field: 'fa_gateway_name',
        sortable: false,
        title: i18n.t('label.gateway_title'),
        width: 140,
        textAlign: 'center'
    },
]